/* loaded by smart-asset */
export default require("./spotify~9fcde0824cd6ad815791a779010daa81ceaed303.svg")